import React from 'react';
import { useAppSelector } from '../../redux/helper';
import {
  selectCartOrderData,
  selectUpdatingCartItems,
} from '../../redux/cartSlice';
import useSaleCustomer from '../../hooks/useSaleCustomer';
import { hasNamedCustomer } from '../../utils/saleCustomer';
import SaleCustomerBar from './SaleCustomerBar';

interface SaleCustomerBannerProps {
  /** Rounded strip for a padded column (the basket on web) instead of an edge-to-edge bar. */
  inset?: boolean;
}

/**
 * The customer bar for whatever is in the cart. A new sale shows the attached
 * customer, removable; a reopened saved order shows the order's customer.
 * Renders nothing for a walk-in.
 */
const SaleCustomerBanner: React.FC<SaleCustomerBannerProps> = ({
  inset = false,
}) => {
  const { customer, removeCustomer } = useSaleCustomer();
  const isEditingSavedOrder = useAppSelector(selectUpdatingCartItems);
  const orderCustomerName = useAppSelector(
    state => selectCartOrderData(state).customerName,
  );

  if (isEditingSavedOrder) {
    return hasNamedCustomer(orderCustomerName) ? (
      <SaleCustomerBar name={orderCustomerName} inset={inset} />
    ) : null;
  }
  if (!customer || !hasNamedCustomer(customer.name)) return null;
  return (
    <SaleCustomerBar
      name={customer.name}
      linked={Boolean(customer.id)}
      onRemove={removeCustomer}
      inset={inset}
    />
  );
};

export default SaleCustomerBanner;
